/**
 * Main javascript entry point
 * Should handle bootstrapping/starting application
 *
 * @author Matej Svajger <hello@matejsvajger.com>
 */

/*global window, document, jQuery, $, require, alert, location, parent, global */

import 'promise-polyfill/src/polyfill';

import Application from './core/app';
import Form from './core/form';
import axios from 'axios';
import swal from 'sweetalert';
import 'sweetalert/dist/sweetalert.css';

/**
 * First we will load all of this project's JavaScript dependencies which
 * include jQuery, Bootstrap, bootstrap-datepicker and bootstrap-select,
 * slick-slider, magnificPopup, mmenu, parsley, sweetalert and
 * cookieconsent. This gives a great starting point for building
 * robust, powerful web applications.
 */

require('./bootstrap');


/**
 * Setup some globals for objects we'll be using across application.
 */
window.Form = Form;
window.axios = axios;
window.swal = swal;

window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest'
};

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

/**
 * Next, we will create a fresh Application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

let App = new Application();

/** Expose the App to browser window object */
window.App = App;


/**
 * Initialize the application on document ready. All code that needs
 * to be executed when page is done, should be handled from within the
 * Application init method.
 */

// $(() => {
//     App.init(); // App initialized in footer;
// })


var wWidth = $(window).width();
var cHeight = $('.claim .dark').height();
$('.claim .bg-image').height(cHeight + 160);

if (wWidth == 768) {
    $('.claim .bg-image').height(cHeight + 60);
}

$(window).resize(function() {
    var cHeight = $('.claim .dark').height();
    $('.claim .bg-image').height(cHeight + 160);
});

$(document).ready(function() {
	$('.popup-gallery').magnificPopup({
		delegate: 'a',
		type: 'image',
		tLoading: 'Loading image #%curr%...',
		mainClass: 'mfp-img-mobile',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
		image: {
			tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
			titleSrc: function(item) {
				return item.el.attr('title');
			}
		}
	});
});
/*$(document).ready(function() {
    $("#cartDropBtn").mouseover(function() {
        $("#cartDropdown").collapse('show');
    });
    $("main").mouseover(function() {
        $("#cartDropdown").collapse('hide');
    });
});*/